import { config } from '@/configs'

import { PublicClientApplication } from '@azure/msal-browser'
import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export enum Provider {
  MSAL = 'entra',
}

type ProviderData = {
  clientId: string
  authority: string
  scopes: string[]
}

export type AuthConfig = {
  entra: ProviderData
}

export type Session = {
  idToken?: string
  accessToken: string
  expiresAt?: number
  provider: Provider
  name?: string
  email?: string
}

const initSession = localStorage.getItem('session')

export const sessionProviderAtom = atomWithStorage<Provider | null>('sessionProvider', null)

export const sessionAtom = atomWithStorage<Session | null>(
  'session',
  initSession && initSession !== 'undefined' ? JSON.parse(initSession) : null,
)

export const msalAtom = atom<PublicClientApplication>(
  new PublicClientApplication({
    auth: {
      clientId: config?.auth.entra.clientId || '',
      authority: config?.auth.entra.authority,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'localStorage',
    },
  }),
)

export const pendingRedirectAtom = atomWithStorage<string | null>('pendingRedirect', null)
